import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {LabelToken} from '@github-ui/label-token'

export function LabeledText({info}: {info: IssueEventInfo}) {
  const {eventType, label} = info
  if (!label?.name) return <>{eventType === 'labeled' ? 'added a label' : 'removed a label'}</>
  return (
    <>
      <span>{eventType === 'labeled' ? 'added the ' : 'removed the '}</span>
      <LabelToken text={label.name} fillColor={label.color ? `#${label.color}` : undefined} />
      <span className="ml-1">label</span>
    </>
  )
}
